import { render } from "./BankVerificationComponent.vue?vue&type=template&id=03364a86"
import script from "./BankVerificationComponent.ts?vue&type=script&lang=js"
export * from "./BankVerificationComponent.ts?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3460111005/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__